import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { ProductService } from './../../../services/product.service';
import { Product } from '../../../models/billing-letter/Product.model';
import { CommonHelper } from './../../../shared/helpers/CommonHelper';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AwsService } from '../../../services/aws.service';
import * as fs from 'fs';

@Component({
  selector: 'app-products-create',
  templateUrl: './products-create.component.html',
  styleUrls: ['./products-create.component.css']
})
export class ProductCreateComponent implements OnInit {
  @ViewChild('uploadInput') uploadInput:ElementRef;
  addProductCheck: boolean = false;
  productForm: FormGroup;
  loading: boolean;
  product: Product = new Product();
  commonHelper: CommonHelper = new CommonHelper();

  dropDownProductshash: any;

  constructor(
              private formBuilder: FormBuilder,
              private productService: ProductService,
              private router: Router,
              public toastr: ToastsManager,
              private awsService: AwsService,
              ) { }

  ngOnInit() {
      this.loading = true;
      this.productForm = this.formBuilder.group({
        name: [null, Validators.required],
        licenseType: null,
        secondarylicenseType: null,
        endCustomerType: null,
        material: null
      });

      this.loading = false;
  }

  async Onsave() {

    try {
        let response = await this.productService.create(this.product);

        if(response._id){
            this.toastr.success('Produto criado com sucesso!');
        } else {
            this.toastr.warning('Erro ao Salvar Produto!')
        }

        this.router.navigate(['/products']);

    } catch (err) {
        console.log(err);
        this.router.navigate(['/products']);
        this.toastr.warning('Erro ao Salvar Produto!')
    }

  }

  cancel() {
      this.product = new Product();
      this.uploadInput.nativeElement.value = '';
  }

  onChange() {
   if (this.productForm.valid) {
        this.addProductCheck = true;
        } else {
            this.addProductCheck = false;
        }
  }


  OnClear() {
      this.product = new Product();
      this.uploadInput.nativeElement.value = '';
  }

  verifyValidTouched(fieldName) {
    return !this.productForm.get(fieldName).valid && this.productForm.get(fieldName).touched;
  }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/products/products-create/products-create.component.ts